import { Box, Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { TopRightCloseButton } from "@src/appV2/redesign/components/TopRightCloseButton";
import { Pill, Text } from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

import travelSuitcaseImage from "./assets/images/travelSuitcase.png";
import { TRAVEL_SHIFTS_BANNER_GRADIENT } from "./constants";

interface TravelShiftsBannerProps {
  onClick: () => void;
  onDismiss: () => void;
}

export function TravelShiftsBanner(props: TravelShiftsBannerProps) {
  const { onClick, onDismiss } = props;

  return (
    <Box sx={{ position: "relative" }}>
      <TopRightCloseButton
        onClick={() => {
          onDismiss();
        }}
      />
      <Stack
        sx={(theme) => ({
          padding: theme.spacing(5),
          borderRadius: theme.borderRadius?.medium,
          background: isRebrandingEnabled()
            ? theme.palette.background.default
            : TRAVEL_SHIFTS_BANNER_GRADIENT,
          ...(isRebrandingEnabled() && {
            border: `1px solid ${String(theme.palette.divider)}`,
          }),
          height: "100%",
          position: "relative",
          overflow: "hidden",
        })}
      >
        <Box
          component="img"
          src={travelSuitcaseImage}
          alt="Travel Suitcase"
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            height: "92%",
            maxHeight: 180,
            aspectRatio: "1 / 1",
            objectFit: "contain",
            pointerEvents: "none",
            transform: "translate(20%, 18%)",
          }}
        />
        <Pill
          label="New"
          size="small"
          {...(isRebrandingEnabled() && {
            backgroundColor: (theme) => theme.palette.intent?.success.background,
            color: (theme) => theme.palette.intent?.success.text,
          })}
          sx={{
            alignSelf: "flex-start",
            position: "relative",
          }}
        />
        <Stack
          gap={5}
          sx={{ flex: 1, justifyContent: "space-between", marginTop: 2, position: "relative" }}
        >
          <Stack gap={3}>
            <Text bold variant="h4">
              Access shifts that require travel
            </Text>
            <Text
              variant="body2"
              sx={{ color: (theme) => theme.palette.text.secondary, maxWidth: "60%" }}
            >
              Interested in traveling to other locations to work more shifts?
            </Text>
          </Stack>
          <Button
            variant="contained"
            size="small"
            sx={{ alignSelf: "flex-start" }}
            onClick={onClick}
          >
            Learn more
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
